import IndividualDevelopmentPlan from './component';
import _routes from './routes';
import { BottomButtons as _BottomButtons } from './IndividualDevelopmentPlanDetailView';

export const routes = _routes;
export const BottomButtons = _BottomButtons;

export default IndividualDevelopmentPlan;



// WEBPACK FOOTER //
// ./containers/Group/IndividualDevelopmentPlan/index.js